// storybook-check-ignore
import React, { PropsWithChildren } from 'react';

import { css } from '@emotion/react';
import { Link } from '@opendoor/bricks/core';
import { novo } from '@opendoor/bricks/theme';

const headerHeight = '72px';

interface NavLinkProps {
  href: string;
  active?: boolean;
  name: string;
}

export const NavLink: React.FC<PropsWithChildren<NavLinkProps>> = ({
  children,
  name,
  href,
  active,
}) => (
  <Link
    alignItems="center"
    color="warmgrey950"
    display="inline-flex"
    lineHeight="100"
    fontWeight="medium"
    py={3}
    px={5}
    h={headerHeight}
    css={css`
      &:visited {
        color: ${novo.colors.warmgrey950};
      }
      &:hover,
      &:focus {
        color: ${novo.colors.brandBlue600};
        outline: 0;
      }
      &:active {
        color: ${novo.colors.brandBlue600};
      }
    `}
    analyticsName={`cosmos-landing-page-v2-nav-link-${name}`}
    aria-label="View link"
    href={href}
    aria-current={active}
  >
    {children}
  </Link>
);
